import { Helmet } from "react-helmet-async";

const OpenGraph = ({ content }) => {
  const { Eid, titre, photo, url, desc } = content;

  // Nettoyage et formatage des données
  const safeTitle = titre || "Mon Coach";
  const safeDescription = desc
    ? desc.replace(/<[^>]*>/g, '').substring(0, 160)
    : "Découvrez nos événements";
  const safeImage = photo || "https://moncoach.tn/logo.jpg";
  const safeUrl = url || `https://moncoach.tn/Evenement/${Eid}`;

  return (
    <Helmet>
   
    
      <meta property="og:title" content={safeTitle} />
      <meta property="og:description" content={safeDescription} />
      <meta property="og:url" content={safeUrl} />
      <meta property="og:site_name" content="Mon Coach" />
      <meta property="og:image" content={safeImage} />
      <meta property="og:image:secure_url" content={safeImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={safeTitle} />

     
    

   
    </Helmet>
  );
};

export default OpenGraph;